<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{ $t('sale_invoice_list') }}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <router-link to="/sale/invoice" class="btn btn-outline-primary btn-sm no-bor">
                <i class="fa fa-plus-circle"></i>
                {{$t('new')}}
            </router-link>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="exportExcel">
                <i class="fa fa-file-excel-o" aria-hidden="true"></i>
                {{$t('export_excel')}}
            </button>
            <div class="pull-right">
                <div class="form-inline">
                    <input type="text" class="form-control form-control-sm max-width" :placeholder="$t('code')" v-model="query.Text" @keypress.enter="toList"/>
                </div>
            </div>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <input type="date" class="form-control form-control-sm" v-model="query.FromDate"/>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <input type="date" class="form-control form-control-sm" v-model="query.ToDate"/>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <select class="form-control form-control-sm" v-model="query.Status" @change="toList">
                                    <option value="">{{$t('all')}}</option>
                                    <option value="Draft">Draft</option>
                                    <option value="Posted">Posted</option>
                                </select>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <div>
                                    <select class="form-control form-control-sm" v-model="query.PStatus" @change="statusChange">
                                        <option value="">{{$t('all')}}</option>
                                        <option value="Not Paid">Not Paid</option>
                                        <option value="Partially Paid">Partially Paid</option>
                                        <option value="Paid">Paid</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('customer')}}</label>
                                <div>
                                    <CustomerDropdown :is-all="true" :place="$t('all')" @select="customerChange"></CustomerDropdown>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="label-control blue">{{$t('sale_reputation')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="query.EmployeeId" @change="toList">
                                        <option value="">{{$t('all')}}</option>
                                        <option v-for="ret in employees" :value="ret.Id" :key="ret.Id">{{ret.Num}} : {{ret.KhmerName}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="label-control blue">&nbsp;</label>
                                <div>
                                    <button type="button" class="btn btn-default btn-sm" @click="toList"><i class="fa fa-search" aria-hidden="true"></i> {{$t('search')}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-sm table-striped no-bor table-scroll">
                        <thead>
                        <tr>
                            <th class="text-center width-column">#</th>
                            <th class="sorting">
                                <span class="sort-field width-column" @click="onSort('Num')">{{ $t('code') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field width-column" @click="onSort('Date')">{{ $t('date') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field width-column" @click="onSort('DueDate')">{{ $t('due_date') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field width-column" @click="onSort('CustomerName')">{{ $t('customer') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field width-column" @click="onSort('SaleRep')">{{ $t('sale_reputation') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field width-column" @click="onSort('DocSource')">{{ $t('type') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field width-column" @click="onSort('DocSourceNo')">{{ $t('ref_num') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field width-column" @click="onSort('GrandTotal')">{{ $t('grand_total') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field width-column" @click="onSort('Discount')">{{ $t('discount') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field width-column" @click="onSort('TotalAmount')">{{ $t('total_amount') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field width-column" @click="onSort('Balance')">{{ $t('balance') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field width-column" @click="onSort('Status')">{{ $t('invoice_status') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field  width-column" @click="onSort('PaidStatus')">{{ $t('payment_status') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                            <th class="sorting">
                                <span class="sort-field width-column" @click="onSort('DueDay')">{{ $t('day_receipt_remain') }}</span>
                                <i class="fa fa-sort" aria-hidden="true"></i>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in list" :key="index">
                                <td class="text-center">{{index+1}}</td>
                                <td>
                                    <router-link :to="{name: 'sale_invoice_view', params: {id: ret.Id}}">{{ret.Num}}</router-link>
                                </td>
                                <td>{{$format(ret.Date, 'DD/MM/YYYY')}}</td>
                                <td>{{$format(ret.DueDate, 'DD/MM/YYYY')}}</td>
                                <td>{{ret.CustomerName}}</td>
                                <td>{{ret.SaleRep}}</td>
                                <td>{{ret.DocSource}}</td>
                                <td>{{ret.DocSourceNo}}</td>
                                <td class="text-right">{{$money(ret.GrandTotal)}}</td>
                                <td class="text-right">{{$money(ret.Discount)}}</td>
                                <td class="text-right">{{$money(ret.TotalAmount)}}</td>
                                <td class="text-right">{{$money(ret.Balance)}}</td>
                                <td class="cell-badge" v-html="$statusLabel(ret.Status)"></td>
                                <td class="cell-badge" v-html="$statusLabel(ret.PaidStatus)"></td>
                                <td class="text-center">{{ret.DueDay}}</td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <th colspan="8"></th>
                                <th class="text-right">{{$money(summary.grand)}}</th>
                                <th class="text-right">{{$money(summary.discount)}}</th>
                                <th class="text-right">{{$money(summary.amount)}}</th>
                                <th class="text-right">{{$money(summary.balance)}}</th>
                                <th></th>
                                <th></th>
                                <th></th>
                            </tr>
                        </tfoot>
                    </table>
                </div>
                <div class="card-footer">
                    <span>{{$t('total_record')}}: {{query.Total}}</span>
                    <div class="pull-right">
                        <b-pagination size="sm" pills :total-rows="query.Total" :per-page="query.Limit" v-model="query.Page" :prev-text="$t('pre')" :next-text="$t('next')"
                        hide-goto-end-buttons
                        @change="paging($event)"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { CustomerDropdown } from '../Customer';
    export default {
        components: { CustomerDropdown },
        data: function(){
            return {
                query:{
                    Text: '',
                    FromDate: '',
                    ToDate: '',
                    Status: '',
                    PStatus: 'Not Paid',
                    Statuses: ['Not Paid'],
                    EmployeeId: '',
                    Page: 1,
                    Total: 0,
                    Limit: 25,
                    SortType: '',
                    SortField: ''
                },
                list: [],
                incomes: [],
                employees: [],
                summary: {
                    grand: 0,
                    discount: 0,
                    tax: 0,
                    amount: 0,
                    balance: 0
                }
            }
        },
        created: function(){
            this.listEmployee();
            this.toList();
        },
        methods: {
            toList(){
                var loading = this.$loading.show();
                this.$api().post('sale/invoices', this.query).then(res => {
                    if(this.$isValid(res)){
                        this.list = res.data.Data;
                        this.query.Total = res.data.Total;
                        this.calculate();
                    }
                }).finally(function() { loading.hide(); });
            },
            calculate(){
                let grand = 0;
                let discount = 0;
                let untax = 0;
                let tax = 0;
                let amount = 0;
                let balance = 0;
                this.list.forEach((item) => {
                    tax += item.TaxVat;
                    grand += item.GrandTotal;
                    discount += item.Discount;
                    untax += item.UntaxAmount;
                    balance += item.Balance;
                    amount += item.TotalAmount;
                });
                this.summary = {
                    grand: grand,
                    untax: untax,
                    tax: tax,
                    discount: discount,
                    amount: amount,
                    balance: balance
                };
            },
            exportExcel(){
                var loading = this.$loading.show();
                this.$api()({
                    url: this.$base() + 'sale/invoice/export/excel',
                    method: 'post',
                    data: this.query,
                    responseType: 'blob'
                }).then(res => {
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'sale-invoice.xlsx');
                    document.body.appendChild(link);
                    link.click();
                }).finally(function(){ loading.hide();});
            },
            onSort(field){
                this.query.SortField = field;
                if(this.query.SortType == 'ASC') this.query.SortType = 'DESC';
                else this.query.SortType = 'ASC';
                this.toList();
            },
            statusChange(){
                if(this.query.PStatus == '') this.query.Statuses = [];
                // else if(this.query.PStatus == 'Not Paid') this.query.Statuses = ['Not Paid','Partially Paid'];
                else this.query.Statuses = [this.query.PStatus];
                this.toList();
            },
            paging(e){
                this.query.Page = e;
                this.toList();
            },
            customerChange(e){
                if(e == null) this.query.CustomerId = '';
                else this.query.CustomerId = e.Id;
                this.toList();
            },
            listEmployee(){
				this.$api().post('employees', { Limit: 0 }).then(res => {
					this.employees = res.data.Data;
				});
			}
        }
    }
</script>
